module.exports = __webpack_public_path__ + "img/company-contract.08b73ee2.svg";